const state = {
  id: null,
  brand_id: null,
  cache_key: null,
  checklist_template_id: null,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'checklist_template_id' },
  { key: 'title' },
]

export default state
